module.exports = __webpack_public_path__ + "img/messager1.c5c1d3a8.png";